<template>
	<div class="layout-split">
		<text-headline-primary v-if="headline" class="headline-primary">
			{{ headline }}
		</text-headline-primary>

		<div class="columns split" :class="{ reverse }">
			<div class="column primary">
				<slot name="primary" />
			</div>
			<div class="column secondary">
				<slot name="secondary" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		headline: {
			type: String,
			required: false,
			default: null
		},
		reverse: {
			type: Boolean,
			required: false,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.headline-primary {
	margin-top: 2rem;
}

.column.primary {
	margin-bottom: 2rem;
}

@media (min-width: $breakpoint-tablet) {
	.columns {
		display: flex;
		flex-direction: row;
	}

	.columns.reverse {
		flex-direction: row-reverse;
	}

	.column.primary {
		flex: 2 1 0px;
		margin-left: 0;
	}

	.columns.reverse .column.primary {
		flex: 1 1 0px;
		margin-left: $layout-gap;
	}

	.column.secondary {
		flex: 1 1 0px;
		margin-left: $layout-gap;
	}

	.columns.reverse .column.secondary {
		flex: 2 1 0px;
		margin-left: 0;
	}
}
</style>
